import React from 'react';
import { useLanguage, LANGUAGES } from '../context/LanguageContext';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';
import { Globe } from 'lucide-react';

const LanguageSwitcher = ({ className = '' }) => {
  const { language, setLanguage } = useLanguage();

  return (
    <Select value={language} onValueChange={setLanguage}>
      <SelectTrigger 
        className={`w-auto gap-2 bg-slate-700/50 border-slate-600 text-white ${className}`}
        data-testid="language-switcher"
      >
        <Globe className="w-4 h-4" />
        <SelectValue>
          {LANGUAGES[language]?.flag} {LANGUAGES[language]?.code.toUpperCase()}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {Object.values(LANGUAGES).map((lang) => (
          <SelectItem key={lang.code} value={lang.code}>
            <span className="flex items-center gap-2">
              <span>{lang.flag}</span>
              <span>{lang.name}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LanguageSwitcher;
